export const APP_NAME = 'AllieHealth';
export const APP_VERSION = '2.0.1';
